import { createFileRoute } from "@tanstack/react-router";
import Compare from "@/pages/Compare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/compare/")({
  head: () => routeHead("/compare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="surface-light min-h-screen"><Compare /></div>
  );
}
